import { createAction } from "@reduxjs/toolkit";

/**
 * Cross-domain actions dispatched from multiple sagas.
 * Handled in rootReducer (store.ts) to reset multiple slices at once.
 */
export const resetImpersonationState = createAction("RESET_IMPERSONATION_STATE");
